import React, { useState, useEffect } from 'react';
import { Button } from '../../components/Buttons';
import { requestAuth } from '../../components/services/RequestService';
import { toast } from 'react-toastify';

const PreviewAnnouncement = ({ values, dialogClose }) => {
  const [data, setData] = useState(null);
  const [selecteds, setSelecteds] = useState([]);
  const [allContacts, setAllContacts] = useState([]);
  const [newEmail, setNewEmail] = useState("");

  useEffect(() => {
    requestAuth('PUT', '/announcement/previous', values)
      .then(response => {
        setData(response.data);

        const mainContacts = response.data?.mainContactsReturn?.map(c => c.email) || [];
        const secondaryContacts = response.data?.secondaryContactsReturn?.map(c => c.email) || [];

        const combinedContacts = [...new Set([...mainContacts, ...secondaryContacts])];

        setAllContacts(combinedContacts);
        setSelecteds(mainContacts);
      })
      .catch(() => {
        toast.error("Se produjo un error al guardar");
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleSecondary = (email) => {
    setSelecteds(prev =>
      prev.includes(email) ? prev.filter(e => e !== email) : [...prev, email]
    );
  };

  const addNewEmail = () => {
    if (newEmail.trim() === "") {
      toast.error("Ingrese un correo válido.");
      return;
    }
    if (!allContacts.includes(newEmail)) {
      setAllContacts(prev => [...prev, newEmail]);
      setSelecteds(prev => [...prev, newEmail]);
      setNewEmail("");
    } else {
      toast.info("El correo ya está en la lista.");
    }
  };

  async function onSubmit() {
    await requestAuth("put", `/announcement/previous`, { ...values, selecteds, send: true })
      .then(() => {
        toast.success("Correos enviados exitosamente!");
        dialogClose();
      })
      .catch(() => {
        toast.error("Se produjo un error al guardar");
      });
  }

  return (
    <div className='bg-white p-2 flex flex-col gap-2 rounded-md mb-4 overflow-hidden'>
      {[
        { label: 'Título:', value: data?.announce?.title },
        { label: 'Asunto:', value: data?.announce?.subject },
        { label: 'Contenido:', value: data?.announce?.content }
      ].map((item, idx) => (
        <LabelInfo key={idx} label={item.label} value={item.value} />
      ))}

      <div className='flex gap-2 text-sm'>
        <span className='font-semibold whitespace-nowrap'>Correos:</span>
        <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-1'>
          {allContacts.map((email, idx) => (
            <span
              key={idx}
              className={`cursor-pointer px-2 py-1 border rounded ${selecteds.includes(email) ? 'bg-blue-200' : 'text-gray-500 hover:bg-gray-200'}`}
              onClick={() => toggleSecondary(email)}
            >
              {email}
            </span>
          ))}
        </div>
      </div>

      <div className='flex items-center gap-2'>
        <input
          type="email"
          className='border p-2 rounded w-full'
          placeholder="Correo"
          value={newEmail}
          onChange={(e) => setNewEmail(e.target.value)}
        />
        <Button type="button" onClick={addNewEmail}>Añadir</Button>
      </div>

      {data?.circulars.map((item, idx) => (
        <LabelFileInfo key={idx} link={item.url} value={item.name} />
      ))}

      <Button className="p-2" type="button" onClick={onSubmit}>
        Enviar
      </Button>
    </div>
  );
};

const LabelInfo = ({ label, value }) => (
  <div className='flex gap-2 text-sm max-w-[600px]'>
    <span className='font-semibold'>{label}</span>
    <span>{value}</span>
  </div>
);

const LabelFileInfo = ({ value, link }) => (
  <a className='flex gap-2 items-center border border-gray-300 rounded p-2' href={link} target="_blank" rel="noopener noreferrer">
    <i className='far fa-file-pdf text-xl text-red-500' />
    <span className='text-sm'>{value}</span>
  </a>
);

export default PreviewAnnouncement;
